import React from "react";
import {
  Row,
  Col,
  Divider,
  Form,
  Input,
  Button,
  message,
  Typography,
} from "antd";
import LoginSignupScreen from "./loginSignupScreen";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
//Action
import { sendOtpForgetPasswordAction } from "../store/action/shared/authAction";
import ForgotPassCard from "./ForgotPassCard";
import AnimatedImages from "./AnimatedImages";

const { Title } = Typography;

function ForgotPass() {
  const dispatch = useDispatch();
  const router = useNavigate();

  const sendOtpForgetPassword = useSelector(
    (state) => state.sendOtpForgetPassword
  );
  const { loading, error } = sendOtpForgetPassword;
  const [form] = Form.useForm();
  const onFinish = async (values) => {
    try {
      await dispatch(sendOtpForgetPasswordAction(values.email));
      form.resetFields();
      router(`/login/`);
    } catch (error) {
      message.error("Please try again later");
    }
  };
  return (
    <>
      <AnimatedImages />
      <ForgotPassCard />
    </>
  );
}

export default ForgotPass;
